module.exports = __webpack_public_path__ + "1793882494189/fonts/Metropolis-Bold.74938f5.woff";